export const errorElements = {
  forAuctionWinDetailModal: {
    errorMessage: (errorMessage) => {
      return <span style={{ color: "red" }}>{errorMessage}</span>;
    },
  },
};
